import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { PortalPage } from "../components/PortalPage";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

interface IState {
  redirectExpired: boolean;
}

export class ErrorPage extends Component<any, IState> {
  /**
   *
   */
  constructor(props: any) {
    super(props);
    this.state = { redirectExpired: false };
  }
  componentDidMount() {
    document.title = "doddl - Error";
  }

  render() {
    if (!this.state.redirectExpired) {
      // On iPhone it doesn't play friendly with the MSAL auth and you get an error page flash
      // up for a brief moment. We have a redirect bandaid for that. So we don't display this
      // error screen immediately, wait three seconds to allow iPhone to auto-fix itself
      setTimeout(() => {
        this.setState({ redirectExpired: true });
      }, 3000);
      return <></>;
    }
    return (
      <PortalPage
        title={<>We are so sorry!</>}
        description={
          "Our portal is experiencing some issues. We are aware of this and are working to resolve the problem as soon as possible."
        }
      >
        <br />
        <p className=" max-w-wide">
          <Link to="/">
            <Button className="btn btn-standard">Go to home page</Button>
          </Link>
        </p>
      </PortalPage>
    );
  }
}
